import { Card } from "../types";
import { cardList } from "./cardList";

export const shuffleCards = (): Card[] =>
  Array.from({ length: 32 })
    .map((_, index) => ({ index, sort: Math.random() }))
    .sort(({ sort: sort1 }, { sort: sort2 }) => sort1 - sort2)
    .map(({ index }) => cardList[index]);
